//Capitalizes the first letter of every word, and remain others small case
export const capitalizeFirstLetter = (str: string): string => {
    return str
        .split(' ')
        .map(word =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
};

//Generates a hierarchical index string based on parent index and current index
export const generateHierarchicalIndex = (parentIndex: string, currentIndex: number): string => {
    return parentIndex?.length ? `${parentIndex}.${currentIndex}` : `${currentIndex}`;
};

export const formatCurrency = (value: number): string => {
    return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};